export default "__VITE_ASSET__c5a9da2c__"